export default __webpack_public_path__ + "static/media/5.03c842fa.svg";